module.exports = __webpack_public_path__ + "img/18.71464003.png";